import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatDateShort } from "../lib/format";
import api from "../lib/api";

export function PopularSidebar() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { sort: "popular", limit: 5 } })
      .then(r => setItems(r.data.items || []))
      .catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="border-t-2 border-black pt-3" data-testid="popular-sidebar">
      <h2 className="overline mb-3">Mais Lidas</h2>
      <ol className="space-y-4">
        {items.map((a, i) => (
          <li key={a.id} className="flex gap-3 border-b border-zinc-200 pb-3 last:border-b-0">
            <span className="font-serif-display text-4xl font-bold leading-none text-red-700">{i + 1}</span>
            <Link to={`/noticia/${a.slug}`} className="flex-1">
              <h3 className="font-serif-display text-base font-semibold leading-tight headline-hover">{a.title}</h3>
              <p className="font-sans-ui text-xs text-zinc-500 mt-1">{a.views || 0} visualizações</p>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}

export function LatestSidebar() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { limit: 6 } })
      .then(r => setItems(r.data.items || []))
      .catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section className="border-t-2 border-black pt-3" data-testid="latest-sidebar">
      <h2 className="overline mb-3">Últimas Notícias</h2>
      <ul className="space-y-3">
        {items.map(a => (
          <li key={a.id} className="border-b border-zinc-200 pb-3 last:border-b-0">
            <Link to={`/noticia/${a.slug}`} className="block">
              {a.category && <span className="overline text-red-700 text-[10px]">{a.category.name}</span>}
              <h3 className="font-serif-display text-sm font-semibold leading-tight headline-hover">{a.title}</h3>
              <time className="font-sans-ui text-[10px] text-zinc-500">{formatDateShort(a.published_at)}</time>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
